import Link from "next/link";

import type { SiteLocale } from "@/lib/graphql";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function DownloadSectionFile(props: {
  record: FragmentOf<typeof fragment.downloadSectionFileFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.downloadSectionFileFragment, props.record);

  return (
    <div>
      <Link
        href={record.file.url}
        className="font-eurac-red group container mx-auto my-10 block max-w-[780px] border-t border-b border-gray-200 py-6 text-[16px]"
      >
        <div className="flex items-start gap-4">
          <div className="shrink-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <g clipPath="url(#clip0_6723_202)">
                <circle
                  cx="20"
                  cy="20"
                  r="19.375"
                  stroke="#DF1B12"
                  strokeWidth="1.25"
                  className="group-hover:fill-eurac-red transition-all"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.1601 10H20.632L20.6077 22.1776L24.4884 18.2968L25.5224 19.3309L20.3887 24.4647C20.3217 24.5342 20.2415 24.5896 20.1526 24.6274C20.0638 24.6651 19.9682 24.6846 19.8717 24.6846C19.7751 24.6846 19.6796 24.6651 19.5908 24.6274C19.502 24.5896 19.4216 24.5342 19.3547 24.4647L14.221 19.3309L15.255 18.2968L19.1601 22.1654V10ZM10 28.5398H29.7927V29.9996H10V28.5398Z"
                  fill="#DF1B12"
                  className="transition-all group-hover:fill-white"
                />
              </g>
              <defs>
                <clipPath id="clip0_6723_202">
                  <rect width="40" height="40" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="space-y-2">
            {record.title && (
              <h2 className="text-base leading-none font-bold text-[#df1b12]">
                {record.title}
              </h2>
            )}
            {record.description && <p className="text-eurac-red">{record.description}</p>}
          </div>
        </div>
      </Link>
    </div>
  );
}
